import React from 'react';
import AjaxLeftRightSelect from "../../../ajax-left-right-select/AjaxLeftRightSelect";

export default (props) => {
    const {
        key,
        value,
        forcedValue,
        data,
        rules,
        options,
        disabled,
        ruleRequired,
        isRequired,
        onChange
    } = props;

    return <AjaxLeftRightSelect
        ItemsSearchParcel={data.ItemsSearchParcel}
        ItemsFetchParcel={data.ItemsFetchParcel}
        defaultValue={value}
        value={forcedValue}
        onChange={onChange}
        title={options.title}
        getSelectedSummary={options.getSelectedSummary}
        getDeselectAllText={options.getDeselectAllText}
        renderOptionContent={options.renderOptionContent}
        getOptionId={options.getOptionId}
        getOptionDisabled={options.getOptionDisabled}
        getOptionCaution={options.getOptionCaution}
        disabled={disabled}
    />;
}
